module.exports = __webpack_public_path__ + "651771e1df95c807c99608188d0a4287.woff";


//////////////////
// WEBPACK FOOTER
// /~/react-notifications/lib/fonts/notification.woff?s3g3t9
// module id = 903
// module chunks = 31